import React from 'react';
import Header from '../components/Header';
import Quality from '../components/Quality';
import Footer from '../components/Footer';

const QualityPage = () => {
  return (
    <div className="App">
      <Header />
      <Quality />
      <Footer />
    </div>
  );
};

export default QualityPage;

